import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import images from "../../utils/imageImports";
import { Link, Navigate } from "react-router-dom";
import Footer from "../layout/Footer";
import PasswordVisibilityToggler from "../../utils/passwordVisibilityToggler";
import LoginValidator from "../../utils/loginValidator";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { connect } from "react-redux";
import { login, googlelogin } from "../../actions/auth";
import { setAlert } from "../../actions/setAlert";

function Login({ login, isAuthenticated, auth: { user }, googlelogin, setAlert }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get('from');

  // for password visibility toggler
  const [passwordInputType, toggleIcon] = PasswordVisibilityToggler();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [user1, setUser1] = useState("");

  const [errors, setErrors] = useState("");

  // checking for errors for the given input values
  useEffect(() => {
    setErrors(LoginValidator(values));
  }, [values]);

  // assigning the values to their respective fields
  function handleChange(e) {
    setValues({ ...values, [e.target.name]: e.target.value });
    setErrors(LoginValidator(values));
  }

  // submitting the form and invoking the api
  const onSubmit = async (e) => {
    e.preventDefault();

    if (errors === "") {
      try {
        login(values);
      } catch (e) {
        console.log(e);
      }
    } else {
      setAlert(errors, "danger");
    }
  };

  // functionality for login with google
  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser1(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (user1) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user1.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user1.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          const { email, id: googleId, verified_email: is_verified, name } = res.data;
          googlelogin({ email, googleId, is_verified, name });
        })
        .catch((err) => console.log(err));
    }
  }, [user1, googlelogin]);

  if (isAuthenticated) {
    if (from === "cart") {
      return <Navigate to="/vyldfyrecard/cart" />;
    } else {
      return <Navigate to="/profile/basicdetails" />;
    }
  }

  return (
    <>
      <header>
        <div className="container">
          <div className="d-none d-sm-block">
            <div className="row pt-4">
              <div className="col-md-6">
                <Link to="/">
                  <img src={images.logo} className="img-fluid" width="208" alt="Vyldfyre Logo" />
                </Link>
              </div>
              <div className="col-md-6 text-end">
                <Link to="/register" className="signbtn">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
          <div className="d-md-none">
            <div className="row">
              <div className="col-md-12 pt-3">
                <Link to="/">
                  <img src={images.logo} width="153" className="img-fluid" alt="Vyldfyre Logo" />
                </Link>
                <Link to="/register" className="signbtn">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
      <section id="main">
        <div id="signin" className="container position-relative">
          <div className="row">
            <div className="col-md-4 mt-3">
              <form className="mt-5" onSubmit={onSubmit}>
                <div className="welcard p-4 mt-5">
                  <p className="mb-5 mt-2">
                    <img src={images.loginIcon} alt="Login Icon" />
                  </p>
                  <h6>Welcome to VYLDFYRE</h6>
                  <p>Please sign in or sign up below.</p>
                  <div className="text-start mt-4">
                    <div className="mb-4">
                      <div className="form-item mb-3">
                        <input
                          type="text"
                          id="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="email">Email</label>
                      </div>
                    </div>
                    <div className="form-item mb-3">
                      <input
                        type={passwordInputType}
                        id="password"
                        value={values.password}
                        onChange={handleChange}
                        name="password"
                        required
                      />
                      <label htmlFor="password">Password</label>
                      <span className="passwordToggle" style={{ color: "white" }}>
                        {toggleIcon}
                      </span>
                    </div>
                    <button
                      type="submit"
                      className="loginbtn my-4 border-0"
                    >
                      Login
                    </button>
                  </div>
                </div>
                <div className="googlecard p-4">
                  <button
                    type="button"
                    className="googlebtn my-2"
                    onClick={() => googleLogin()}
                  >
                    <img src={images.googleIcon} className="pe-2" alt="Google Icon" /> Log in with Google
                  </button>
                </div>
                <p className="text-center pt-4 mb-5">
                  Don't have an account?{" "}
                  <Link to="/register" className="linkyellow1">
                    Sign up
                  </Link>
                </p>
              </form>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-7 dispnone">
              <img src={images.innerBg} className="img-fluid w-100" alt="Background" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  googlelogin: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  auth: state.auth,
});

export default connect(mapStateToProps, { login, googlelogin, setAlert })(Login);
